// extracted by mini-css-extract-plugin
module.exports = {"container":"signup_container__4jH4m","loginBox":"signup_loginBox__20juP"};